import { inject } from "vue"
import { handleError } from "@shared/helpers/utils"
import { errorMessage, successMessage } from "@shared/helpers/message"
import { useGlobalStore } from "@/stores/global-store"
import { useUserStore } from "@/stores/user-store"
import { useColors } from "vuestic-ui"
import { MenuHierarchy } from "@/pages/admin/menuHierarchy/types"
import { useRouter } from "vue-router"

export const useCommon = () => {
  const userStore = useUserStore()
  const router = useRouter()
  const axios: any = inject("$baseHttpClient")
  const { applyPreset } = useColors()

  const impersonate = async (userName: string): Promise<boolean> => {
    const globalStore = useGlobalStore()
    try {
      const response = await axios.post("/Authentication/Impersonate", { userName })
      if (!response.data.success) {
        handleError(response.data.error)
        return false
      }
      globalStore.setUserPreferences(response.data.result.preferences ?? [])
      userStore.setUser(response.data.result)
      router.push({ name: "home" })
      successMessage("impersonate.messages.impersonationStarted")
      return true
    } catch (error) {
      handleError(error)
      throw error
    }
  }

  const saveSettings = async (code: string, value: string) => {
    try {
      const response = await axios.put("/UserPreference/", { code, value })
      if (!response.data.success) {
        errorMessage(response.data.error)
      }
    } catch (error) {
      handleError(error)
      throw error
    }
  }

  const getSettings = async () => {
    const globalStore = useGlobalStore()
    try {
      if (!userStore.isAuthenticated) {
        return
      }
      const response = await axios.get("/UserPreference")
      if (response.status === 204) return
      if (response.status === 200 && response.data) {
        globalStore.setUserPreferences(response.data)
        applyPreset(response.data.selectedTheme ?? "light")
      } else {
        errorMessage(response.data.error)
      }
    } catch (error) {
      handleError(error)
      throw error
    }
  }

  const getMenuHierarchy = async (): Promise<MenuHierarchy[]> => {
    const globalStore = useGlobalStore()
    try {
      if (!userStore.isAuthenticated) {
        return []
      }
      const response = await axios.get("/MenuHierarchy")

      if (response.status === 200) {
        globalStore.setMenuHierarchy(response.data)
        return response.data
      } else {
        errorMessage(response.data.error)
      }
      return []
    } catch (error) {
      handleError(error)
      throw error
    }
  }

  return {
    getSettings,
    saveSettings,
    impersonate,
    getMenuHierarchy,
  }
}
